import React, { useMemo } from 'react';
import PostFeedItemCard from './items/PostFeedItemCard';
import CourseFeedItemCard from './items/CourseFeedItemCard';
import { getFeedItemKind } from './utils/feedItemType';

export default function FeedList({ groupId, items }) {
  const sorted = useMemo(() => {
    const arr = Array.isArray(items) ? [...items] : [];
    // pinned first, then newest first (backend already sorts, but keep safe)
    arr.sort((a, b) => {
      const ap = a?.is_pinned ? 1 : 0;
      const bp = b?.is_pinned ? 1 : 0;
      if (ap !== bp) return bp - ap;
      const at = a?.created_at ? Date.parse(a.created_at) : 0;
      const bt = b?.created_at ? Date.parse(b.created_at) : 0;
      return bt - at;
    });
    return arr;
  }, [items]);

  return (
    <div className="space-y-4">
      {sorted.map((item) => {
        const kind = getFeedItemKind(item);
        if (kind === "course") {
          return <CourseFeedItemCard key={item.id} groupId={groupId} item={item} />;
        }
        return <PostFeedItemCard key={item.id} groupId={groupId} item={item} />;
      })}
    </div>
  );
}
